import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 型材列表
export const setSectionBarPage: Mutation<IModuleState> = (state, payload) => {
  state.sectionBarPage.data = payload.data;
  state.sectionBarPage.pageNum = payload.pageNum;
  state.sectionBarPage.pageSize = payload.pageSize;
  state.sectionBarPage.total = payload.total;
  state.sectionBarPage.loading = !!payload.loading;
};

// 型材详情
export const setSectionBarDetail: Mutation<IModuleState> = (state, payload) => {
  state.sectionBarDetail.data = payload.data;
  state.sectionBarDetail.loading = !!payload.loading;
};

// confirm 弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

// 设置列表搜索条件
export const setSearch: Mutation<IModuleState> = (state, payload) => {
  state.search = payload;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
